import styled from "styled-components";

const Li = styled.li`
  color: ${(props) => props.theme.color.black};
  font-size: 15px;
  margin-top: 8px;
`;

export default Li;
